import { UnifiedKpiEvent, UnifiedKpiFlowMessage, State } from './types/types'

export const FinosDynamicChartSetReducer: WidgetReducerType<UnifiedKpiEvent, UnifiedKpiFlowMessage> = (
    state: State = { loading: true, events: [], hasLoadedFullHistory: false, finosMetadata: undefined },
    message: any
) => {
    if (!message) {
        return state
    }
    if (message.baseline && message.type !== 'event') {
        return state
    }
    switch (message.type) {
        case 'start':
            return { loading: true, hasLoadedFullHistory: false, events: [], finosMetadata: message?.events?.info?.finos_metadata } as State
        case 'event':
            return { ...state, loading: !state.hasLoadedFullHistory, events: [...state.events, ...message.events] } as State
        case 'endHistory':
            return { ...state, loading: false, hasLoadedFullHistory: true, events: state.events } as State
        default:
            return state
    }
}
